// UserContext.js
import { createContext } from "react";

const SubjectsContext = createContext({});
export default SubjectsContext;
